import { Component, computed, inject, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ContextService } from '../../core/context/context.service';

/** Administration pages, in menu order. App admins see the ones not marked platformOnly. */
const ADMIN_LINKS = [
  { route: '/admin/organisation', icon: 'corporate_fare', label: 'Organisation', platformOnly: true },
  { route: '/admin/people', icon: 'badge', label: 'People & access', platformOnly: false },
  { route: '/admin/access', icon: 'admin_panel_settings', label: 'App access setup', platformOnly: false },
  { route: '/admin/forms', icon: 'dynamic_form', label: 'Forms', platformOnly: false },
  { route: '/admin/workflows', icon: 'account_tree', label: 'Workflows', platformOnly: false },
  { route: '/admin/applications', icon: 'apps', label: 'Applications', platformOnly: true },
  { route: '/admin/org-import', icon: 'upload_file', label: 'SAP import', platformOnly: true },
];

/** Navigation: home, my approvals, the applications I may open, and administration for admins and app admins. */
@Component({
  selector: 'app-sidebar',
  imports: [MatIconModule, MatListModule, MatTooltipModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  readonly context = inject(ContextService);
  readonly navigate = output<void>();
  readonly adminLinks = computed(() => ADMIN_LINKS.filter((l) => !l.platformOnly || this.context.isAdmin()));
}
